import { render, staticRenderFns } from "./zdyrbfengren.vue?vue&type=template&id=1a7fe195&scoped=true&"
import script from "./zdyrbfengren.vue?vue&type=script&lang=js&"
export * from "./zdyrbfengren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7fe195",
  null
  
)

export default component.exports